import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../icons";
import { DeliveryRecord, listDeliveries } from "../../../api";

export function DeliveryVerificationPanel() {
  const { t } = useTranslation("dashboard");
  const [active, setActive] = useState<DeliveryRecord | null>(null);

  useEffect(() => {
    const tick = async () => {
      try {
        const inProg = await listDeliveries({ status: "in_progress" });
        if (inProg.length > 0) {
          setActive(inProg[0]);
          return;
        }
        const pending = await listDeliveries({ status: "pending" });
        setActive(pending[0] ?? null);
      } catch {
        // silent
      }
    };
    void tick();
    const t = setInterval(tick, 15_000);
    return () => clearInterval(t);
  }, []);

  if (!active) {
    return (
      <>
        <header className="panel-head">
          <h3>
            <Icon name="boxes" size={18} /> {t("panels.delivery.title")}
          </h3>
          <span className="panel-tag">{t("panels.delivery.noActiveTag")}</span>
        </header>
        <div className="empty-card">
          <Icon name="boxes" /> {t("panels.delivery.noActiveCard")}
        </div>
      </>
    );
  }

  return (
    <>
      <header className="panel-head">
        <h3>
          <Icon name="boxes" size={18} /> {t("panels.delivery.title")}
        </h3>
        <span className="panel-tag">{active.destination_label}</span>
      </header>
      <div className="delivery-body">
        <div className="delivery-summary">
          <div className="delivery-count">
            <div className="delivery-num">{active.ok_count}</div>
            <div className="delivery-of">/ {active.manifest_count}</div>
          </div>
          <div className="delivery-meta">
            <div className="delivery-label">{t("panels.delivery.downloadedBoxes")}</div>
            <div className="delivery-pct">%{active.progress_pct}</div>
          </div>
        </div>
        <div className="progress-track">
          <div className="progress-fill" style={{ width: `${active.progress_pct}%` }} />
        </div>
        <div className="delivery-route">
          <div>
            <strong>{t("panels.delivery.vehicle")}:</strong> {active.vehicle_id ?? "—"} ·{" "}
            <strong>{t("panels.delivery.target")}:</strong> {active.destination_label}
          </div>
          <div className="muted small">
            {t("panels.delivery.scanCount", { count: active.scanned_count })} · {t("panels.delivery.ok", { count: active.ok_count })}
          </div>
        </div>
      </div>
    </>
  );
}
